import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import Export from 'components/ModalWindows/Export';
import { hasBothMobileAndDesktopViews } from 'containers/Common/selectors';
import { countryAbbreviations } from 'containers/CountryAbbreviations/selectors';
import { hideModal } from 'containers/ModalManager/actions';
import { projectType } from 'containers/Project/selectors';
import { targetCountry } from 'containers/RootDocument/selectors';
import { exportPackage } from './actions';

const mapStateToProps = createStructuredSelector({
  projectType,
  hasBothMobileAndDesktopViews,
  targetCountry,
  countryAbbreviations,
});

const mapDispatchToProps = {
  exportPackage,
  hideModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(Export);
